<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商工作移交</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>招商工作移交</span>
      </div>

      <!-- 操作区域 -->
      <el-form :inline="true" size="small">
        <el-form-item label="移交方：">
          <el-select v-model="fromId" placeholder="请选择移交方" clearable @change="onFromChange">
            <el-option
              v-for="emp in employees"
              :key="emp._id"
              :label="emp.name + ' (' + emp.job + ')'"
              :value="emp._id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="接收方：">
          <el-select v-model="toId" placeholder="请选择接收方" clearable>
            <el-option
              v-for="emp in employees"
              :key="emp._id"
              :label="emp.name + ' (' + emp.job + ')'"
              :value="emp._id"
              :disabled="emp._id === fromId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleTransferAll" :disabled="!fromId || !toId">一键移交</el-button>
          <el-button type="warning" @click="handleTransferByCustomers" :disabled="!fromId || !toId">按客户移交</el-button>
        </el-form-item>
      </el-form>

      <!-- 客户列表（按客户移交时显示） -->
      <div v-if="showCustomerTable" style="margin-top: 20px">
        <div style="margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between">
          <span style="font-weight: bold">
            移交方的客户列表（共 {{ customerList.length }} 个，已选 {{ selectedCustomers.length }} 个）
          </span>
          <el-input
            v-model="customerKeyword"
            placeholder="搜索客户名称/联系人/电话"
            prefix-icon="el-icon-search"
            clearable
            size="small"
            style="width: 280px"
          ></el-input>
        </div>
        <el-table
          :data="filteredCustomerList"
          border
          @selection-change="handleSelectionChange"
          ref="customerTable"
          height="calc(100vh - 350px)"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="客户名称" prop="title"></el-table-column>
          <el-table-column label="联系人" prop="name"></el-table-column>
          <el-table-column label="电话" prop="mobile"></el-table-column>
          <el-table-column label="来源" prop="from"></el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.createDate | dateFormat }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      employees: [],
      fromId: '',
      toId: '',
      customerList: [],
      selectedCustomers: [],
      showCustomerTable: false,
      customerKeyword: ''
    }
  },
  computed: {
    filteredCustomerList () {
      if (!this.customerKeyword) return this.customerList
      const kw = this.customerKeyword.toLowerCase()
      return this.customerList.filter(c =>
        (c.title && c.title.toLowerCase().includes(kw)) ||
        (c.name && c.name.toLowerCase().includes(kw)) ||
        (c.mobile && c.mobile.includes(kw))
      )
    }
  },
  created () {
    this.getEmployees()
  },
  methods: {
    async getEmployees () {
      const { data: res } = await this.$http.get('zhaoshang/workTransfer/employees')
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.employees = res.data
    },

    onFromChange (val) {
      this.selectedCustomers = []
      this.customerKeyword = ''
      if (val) {
        this.loadCustomers()
      } else {
        this.showCustomerTable = false
        this.customerList = []
      }
    },

    async loadCustomers () {
      if (!this.fromId) return
      const { data: res } = await this.$http.get('zhaoshang/workTransfer/customers', {
        params: { creatorId: this.fromId }
      })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.customerList = res.data.list
      this.showCustomerTable = true
    },

    handleSelectionChange (val) {
      this.selectedCustomers = val
    },

    async handleTransferAll () {
      if (!this.fromId || !this.toId) {
        return this.$message.warning('请选择移交方和接收方')
      }

      const fromName = this.employees.find(e => e._id === this.fromId).name
      const toName = this.employees.find(e => e._id === this.toId).name

      try {
        await this.$confirm(
          `是否确定要将【${fromName}】的招商数据移交给【${toName}】`,
          '提示',
          { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch {
        return
      }

      const { data: res } = await this.$http.post('zhaoshang/workTransfer/transferAll', {
        fromId: this.fromId,
        toId: this.toId
      })

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(`移交成功，共移交 ${res.data.customerCount} 个客户`)
      this.showCustomerTable = false
      this.customerList = []
      this.selectedCustomers = []
    },

    async handleTransferByCustomers () {
      if (!this.fromId || !this.toId) {
        return this.$message.warning('请选择移交方和接收方')
      }
      if (this.selectedCustomers.length === 0) {
        return this.$message.warning('请至少选择一个客户')
      }

      const toName = this.employees.find(e => e._id === this.toId).name

      try {
        await this.$confirm(
          `是否确定要将所选客户移交给【${toName}】`,
          '提示',
          { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
        )
      } catch {
        return
      }

      const customerIds = this.selectedCustomers.map(c => c._id)

      const { data: res } = await this.$http.post('zhaoshang/workTransfer/transferByCustomers', {
        fromId: this.fromId,
        toId: this.toId,
        customerIds
      })

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success(`移交成功，共移交 ${res.data.customerCount} 个客户`)
      this.loadCustomers()
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix::after {
  content: '';
  display: table;
  clear: both;
}
</style>
